// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9ab27f58","453":"5bcde57f","455":"a77dc869","977":"fe4d898c"}[chunkId] + ".chunk.js";
};